import { ReturnTranslatedText } from '@wajeez-web/core/localization';

interface FormSectionTitleProps {
  title: string;
  sectionNumber?: number;
}

export const FormSectionTitle = ({
  title,
  sectionNumber,
}: FormSectionTitleProps) => {
  return (
    <div className="mb-4 w-full flex justify-start items-center">
      {sectionNumber ? (
        <div className="w-5 h-5 flex justify-center items-center bg-[#212529] rounded-full text-white text-[15px] font-medium">
          {sectionNumber}
        </div>
      ) : null}
      <div
        className={`${
          sectionNumber
            ? 'rtl:mr-2 ltr:ml-2 font-medium text-[19px]'
            : 'underline underline-offset-4 font-bold text-[18px]'
        }`}
      >
        <ReturnTranslatedText text={`general.${title}`} origintext={title} />
      </div>
    </div>
  );
};
